(function () {
  'use strict';

  (function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();
    let windowWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      let newWidth = window.innerWidth;

      if (newWidth === windowWidth) {
        return;
      }

      let headerSection = document.getElementById('Header');
      let announcementBarSection = document.getElementById('AnnouncementBar');
      let pageHeader = document.getElementById('PageHeader');
      windowWidth = newWidth;
      document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');

      if (headerSection) {
        document.documentElement.style.setProperty('--tg-header-height', headerSection.offsetHeight + 'px');
      }

      if (announcementBarSection) {
        document.documentElement.style.setProperty('--tg-announcement-bar-height', announcementBarSection.offsetHeight + 'px');
      }

      if (pageHeader) {
        document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.offsetHeight + 'px');
      }
    });
  })();

  // Seleziona automaticamente la taglia L al caricamento della pagina prodotto
  (function() {
    // Controlla se siamo su una pagina prodotto
    if (document.querySelector('.Product')) {
      // Controlla se c'è già un parametro variant nell'URL
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('variant')) {
        return; // Non forzare la taglia L se c'è già un parametro variant
      }

      // Attendi che il DOM sia completamente caricato
      setTimeout(function() {
        const variantPicker = document.querySelector('.Product__Block--variantPicker');
        if (!variantPicker) return;

        const options = variantPicker.querySelectorAll('.ProductForm__Option');
        const colorKeywords = ['color', 'colour', 'couleur', 'colore', 'farbe', 'färg', 'farve', 'kleur', 'barva', 'väri', '색상', '색', '色', 'farge', 'kolor', 'cor', 'สี', 'renk', 'màu sắc', '颜色', '顏色'];
        let sizeOptionFound = false;

        options.forEach(function(optionElement) {
          if (sizeOptionFound) return;

          const optionLabel = optionElement.querySelector('.ProductForm__Label');
          if (!optionLabel) return;

          const optionName = optionLabel.textContent.trim().toLowerCase();
          // Controlla se è un'opzione taglia (non colore)
          const isColorOption = colorKeywords.some(function(keyword) {
            return optionName.includes(keyword);
          });

          if (!isColorOption) {
            // Questa è probabilmente l'opzione taglia
            // Cerca un input radio o select con valore "L"
            const radioInputs = optionElement.querySelectorAll('input[type="radio"]');
            const selectElement = optionElement.querySelector('select.Form__Select');

            if (radioInputs.length > 0) {
              radioInputs.forEach(function(input) {
                if (sizeOptionFound) return;
                const value = input.value.trim().toLowerCase();
                const parentLi = input.closest('li');
                const isUnavailable = parentLi && parentLi.classList.contains('Unavailable');

                // Controlla se il valore è "L" e se la variante è disponibile
                if ((value === 'l' || value === ' l' || value === 'l ') && input.dataset.variantId && !isUnavailable) {
                  // Seleziona questo input
                  input.checked = true;
                  // Triggera l'evento change per aggiornare la variante
                  const changeEvent = new Event('change', { bubbles: true });
                  input.dispatchEvent(changeEvent);
                  sizeOptionFound = true;
                }
              });
            } else if (selectElement) {
              // Cerca l'opzione "L" nel select
              const selectOptions = selectElement.querySelectorAll('option');
              for (let i = 0; i < selectOptions.length; i++) {
                if (sizeOptionFound) break;
                const option = selectOptions[i];
                const value = option.value.trim().toLowerCase();
                // Controlla se il valore è "L" e se la variante è disponibile
                if ((value === 'l' || value === ' l' || value === 'l ') && option.dataset.variantId && !option.classList.contains('Unavailable')) {
                  selectElement.selectedIndex = i;
                  selectElement.value = option.value;
                  // Triggera l'evento change per aggiornare la variante
                  const changeEvent = new Event('change', { bubbles: true });
                  selectElement.dispatchEvent(changeEvent);
                  sizeOptionFound = true;
                }
              }
            }
          }
        });
      }, 500); // Delay di 500ms per assicurarsi che il DOM sia pronto
    }
  })();

})();
